// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"600eb6e5","325":"6c5aabd4","418":"f88ab24b","551":"791597ab","789":"de275cba"}[chunkId] + ".chunk.js";
};